import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import {SettingsService} from "./settings.service";

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {
	private gtmId: string | null = null; // = environment?.gtmId ?? null;
	private loaded = false;

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private settingsService: SettingsService

	) {}

	enableTracking(): void {
		if (this.loaded) {
			this.updateConsent('granted');
			return;
		}

		const configuredId = this.settingsService.get('GOOGLE_TAG_MANAGER_ID') ?? null;

		if (!configuredId) {
			console.warn('no Google Tag Manager ID configured.');
			return;
		}

		this.gtmId = configuredId.trim();

		console.log("enable tracking for ID = ", this.gtmId);

		const w = window as Window & {
			dataLayer?: unknown[];
			gtag?: (...args: unknown[]) => void;
		};

		w.dataLayer = w.dataLayer || [];
		w.gtag = (...args: unknown[]) => {
			w.dataLayer!.push(args);
		};

		// disallow tracking by default
		w.gtag('consent', 'default', {
			analytics_storage: 'denied',
			ad_storage: 'denied',
			ad_user_data: 'denied',
			ad_personalization: 'denied'
		});

		w.dataLayer.push({
			'gtm.start': Date.now(),
			event: 'gtm.js'
		});

		const script = this.document.createElement('script');
		script.async = true;
		script.src =
			`https://www.googletagmanager.com/gtm.js?id=${this.gtmId}`;

		this.document.body.insertBefore(
			script,
			this.document.body.firstChild
		);

		this.loaded = true;

		this.updateConsent('granted');
	}

	disableTracking(): void {
		this.updateConsent('denied');
	}

	private updateConsent(
		consent: 'granted' | 'denied'
	): void {
		const w = window as Window & {
			gtag?: (...args: unknown[]) => void;
		};

		w.gtag?.('consent', 'update', {
			analytics_storage: consent,
			ad_storage: consent,
			ad_user_data: consent,
			ad_personalization: consent
		});
	}
}
